import { FIND_PROCESS_STATEMENT_REQUEST, findProcessStatementSuccess, findProcessStatementFailure } from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from, EMPTY } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findProcessStatementEpic(action$, store$, { ProcessStatementRepository }) {
    return action$.pipe(
        ofType(FIND_PROCESS_STATEMENT_REQUEST),
        mergeMap( action =>{
            const { id } = action.payload;

            if(!`${id}`.trim()) {
                return EMPTY;
            }

            return from(
                ProcessStatementRepository.findById( id )
                    .then(statement => findProcessStatementSuccess( statement ))
                    .catch(error => findProcessStatementFailure(error)),
            );
        }),
    );
}
